import type { ConnectorDefinition } from "../types";

export const knowledgeEngineConnector: ConnectorDefinition = {
  id: "knowledgeEngine",
  name: "B&G Knowledge Engine",
  description:
    "Search internal documents, projects, people, and company knowledge",
  icon: "knowledgeEngine",
  authType: "system",
  system: {
    token: { from: "login", loginProvider: "microsoft" },
    resolvesToken: true,
  },
  isEnabled: () => true,
};
